import { Typography } from '@mui/material';

function AmountDisclaimer() {
    return (
        <Typography variant="h6">
            Ce montant inclut 150 euros de frais de dossier, non remboursables en cas de désistement
            avant le 5 septembre. Passé le 5 septembre, les frais de scolarité sont dûs dans leur
            entièreté.
        </Typography>
    );
}

export { AmountDisclaimer };
